export const CONTACT_EMAIL = 'thelumora.cc@gmail.com';
export const CONTACT_PHONE = '03039936931';
export const CONTACT_PHONE_DISPLAY = '0303 9936931';

export const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/thelumora.cc?igsh=dWlwend0Njk2eG4z&utm_source=qr',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61591637908904',
  },
];
